import React from 'react';
import { Button } from '../../../../Button';
import MuiModal, { MuiModalProps } from '../../../../../mui/MuiModal/MuiModal';

export type InvoiceViewPayButtonPaymentSentModalProps = Pick<
	MuiModalProps['muiModalProps'],
	'open' | 'onClose'
>;

const InvoiceViewPayButtonPaymentSentModal: React.FC<
	InvoiceViewPayButtonPaymentSentModalProps
> = ( { open, onClose } ) => (
	<MuiModal
		title='Your payment has been sent'
		description='It may take a few days to reflect on your account.'
		muiModalProps={ {
			open,
			onClose,
			slotProps: {
				paper: { 'data-cy': 'pay-installments-payment-sent-modal' },
			},
		} }
		controls={ <Button href='/invoices'>Back to invoices</Button> }
	/>
);

export default InvoiceViewPayButtonPaymentSentModal;
